<div [class]="styleClass">
  <div>（モーダルのメイン部分のHTML）</div>
  <div class="testTitle">
    <p>注意喚起エリア（メッセージID指定）</p>
    ID: <input type="text" id="message-id-input" name="message-id-input" class="testInput" #messageId />
    <button id="alert-clear-id" class="testButton" (click)="alertClear()">storeクリア</button><br />
    <button id="alert-warning-id-sub-on" class="testButton" (click)="warningIdOn(messageId.value)">
      ワーニング追加
    </button>
    <button id="alert-warning-id-sub-delete" class="testButton" (click)="warningIdDelete(messageId.value)">
      ワーニング削除
    </button>
    <button id="alert-infomation-id-sub-on" class="testButton" (click)="infomationIdOn(messageId.value)">
      インフォメーション追加
    </button>
    <button id="alert-infomation-id-sub-delete" class="testButton" (click)="infomationIdDelete(messageId.value)">
      インフォメーション削除
    </button>
  </div>
</div>
